module.exports = __webpack_public_path__ + "static/media/green-icon.3da57a26.png";